import {
    FETCH_ALL_JOBS_URL,
    SCHEDULE_JOB_URL,
    UNSCHEDULE_JOB_URL,
    RUN_JOB_URL,
    EDIT_JOB_URL,
    CHANGE_JOB_STATUS_URL,
    CHANGE_JOB_SCHEDULE_STATUS_URL,
} from "./URL";
import { http } from "./http";

export interface JobFilters {
    jobName: string[];
    enabled: string[];
    scheduled: string[];
    scheduleType: string[];
}

export interface JobRequest {
    jobName: string;
    scheduleTime?: string;
    scheduleType?: string;
    inActiveDate?: string;
}

export interface EditJobRequest {
    jobId: string;
    scheduleType: string;
    scheduleTime: string;
    dayOfWeek?: string;
    dayOfMonth?: number;
    description?: string | null;//CS-1571
    auditUserId?: string;
}

export interface ChangeJobStatusRequest {
    jobId: string;
    auditUserId?: string;
    isActive: boolean;
    isScheduled: boolean;
}

export const fetchAllJobs = async () => {
    try {
        // Based on the controller, this should be a GET request
        const response = await http.get(FETCH_ALL_JOBS_URL);
        return response;
    } catch (error) {
        throw error;
    }
};

export const scheduleJob = async (jobName: string, scheduleData?: Partial<JobRequest>) => {
    try {
        const jobRequest: JobRequest = {
            jobName,
            ...scheduleData
        };
        const response = await http.post(SCHEDULE_JOB_URL, jobRequest);
        return response;
    } catch (error) {
        throw error;
    }
};

// export const unscheduleJob = async (jobName: string) => {
//     try {
//         const jobRequest: JobRequest = {
//             jobName
//         };
//         const response = await http.post(UNSCHEDULE_JOB_URL, jobRequest);
//         return response;
//     } catch (error) {
//         throw error;
//     }
// };

export const runJobNow = async (jobName: string) => {
    try {
        const jobRequest: JobRequest = {
            jobName
        };
        const response = await http.post(RUN_JOB_URL, jobRequest);
        return response;
    } catch (error) {
        throw error;
    }
};

export const editJobDetails = async (editJobRequest: EditJobRequest) => {
    try {
        const response = await http.post(EDIT_JOB_URL, editJobRequest);
        return response;
    } catch (error) {
        throw error;
    }
};

export const changeJobStatus = async (changeJobStatusRequest: ChangeJobStatusRequest) => {
    try {
        const response = await http.post(CHANGE_JOB_STATUS_URL, changeJobStatusRequest);
        return response;
    } catch (error) {
        throw error;
    }
};

export const changeJobScheduleStatus = async (changeJobStatusRequest: ChangeJobStatusRequest) => {
    try {
        const response = await http.post(CHANGE_JOB_SCHEDULE_STATUS_URL, changeJobStatusRequest);
        return response;
    } catch (error) {
        throw error;
    }
};